// Plate renders <div contenteditable>, so a tag check alone is not enough
const EDITABLE_SELECTOR =
  '[contenteditable=""], [contenteditable="true"], [contenteditable="plaintext-only"]'

export const allowEventTarget = (event: KeyboardEvent) => {
  const target = event.target as HTMLElement | null
  if (!target) {
    return true
  }

  const tag = target.tagName.toLowerCase()
  const isEditable =
    tag === 'input' ||
    tag === 'textarea' ||
    Boolean(target.closest?.(EDITABLE_SELECTOR)) ||
    target.classList.contains('public-DraftEditor-content')

  return !isEditable
}
